/* tslint:disable */
/* eslint-disable */
/**
 * GlassHouse.Dashboard.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { GetBalanceDetailResponse } from './GetBalanceDetailResponse';
import {
    GetBalanceDetailResponseFromJSON,
    GetBalanceDetailResponseFromJSONTyped,
    GetBalanceDetailResponseToJSON,
    GetBalanceDetailResponseToJSONTyped,
} from './GetBalanceDetailResponse';
import type { GetBalanceResponse } from './GetBalanceResponse';
import {
    GetBalanceResponseFromJSON,
    GetBalanceResponseFromJSONTyped,
    GetBalanceResponseToJSON,
    GetBalanceResponseToJSONTyped,
} from './GetBalanceResponse';

/**
 * 
 * @export
 * @interface GetBalanceByUserIdResponse
 */
export interface GetBalanceByUserIdResponse {
    /**
     * 
     * @type {GetBalanceResponse}
     * @memberof GetBalanceByUserIdResponse
     */
    unit?: GetBalanceResponse;
    /**
     * 
     * @type {Array<GetBalanceDetailResponse>}
     * @memberof GetBalanceByUserIdResponse
     */
    unitDetails?: Array<GetBalanceDetailResponse>;
}

/**
 * Check if a given object implements the GetBalanceByUserIdResponse interface.
 */
export function instanceOfGetBalanceByUserIdResponse(value: object): value is GetBalanceByUserIdResponse {
    return true;
}

export function GetBalanceByUserIdResponseFromJSON(json: any): GetBalanceByUserIdResponse {
    return GetBalanceByUserIdResponseFromJSONTyped(json, false);
}

export function GetBalanceByUserIdResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetBalanceByUserIdResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'unit': json['unit'] == null ? undefined : GetBalanceResponseFromJSON(json['unit']),
        'unitDetails': json['unitDetails'] == null ? undefined : ((json['unitDetails'] as Array<any>).map(GetBalanceDetailResponseFromJSON)),
    };
}

export function GetBalanceByUserIdResponseToJSON(json: any): GetBalanceByUserIdResponse {
    return GetBalanceByUserIdResponseToJSONTyped(json, false);
}

export function GetBalanceByUserIdResponseToJSONTyped(value?: GetBalanceByUserIdResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'unit': GetBalanceResponseToJSON(value['unit']),
        'unitDetails': value['unitDetails'] == null ? undefined : ((value['unitDetails'] as Array<any>).map(GetBalanceDetailResponseToJSON)),
    };
}

